import { createSelector } from 'reselect'

export const getCartLoading = createSelector(
  (state) => state && state.cart && state.cart.list && state.cart.list.isLoading,
  isLoading => isLoading
)
